import { baseApi } from "./baseAPI"
import { Group } from "../dtos/groups/group";
import GroupCustomer from "../dtos/groups/GroupCustomer";
import DepartmentMeasurements from "../dtos/groups/DepartmentMeasurements";
import DepartmentProductGroup from "../dtos/groups/DepartmentProductGroup";
import GroupCriteria, { getQueryFromGroupCriteria } from "../dtos/groups/GroupCriteria";
import { handleUrl } from "../../helpers/utils";

export const groupsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getGroups: build.query<Group[], GroupCriteria | void>({
            query: (data) => handleUrl("departments", getQueryFromGroupCriteria(data))
            ,
            // Cache for id
            providesTags: (_result, _error, groups) => [{ type: 'groups', id: 'LIST'}],
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        }),
        getDepartmentCustomers: build.query<GroupCustomer[], Group>({
            query: (group) => `departments/${group.id}/customers`,
            // Cache for id
            providesTags: (_result, _error, groups) => [{ type: 'groupcustomers', id: groups.id}],
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        }),
        getDepartmentMeasurements: build.query<DepartmentMeasurements | null, Group>({
            query: (group) => `departments/${group.id}/measurements`,
            // Cache for id
            providesTags: (_result, _error, groups) => [{ type: 'department_measurements', id: _result?.groupId}],
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        }),
        getDepartmentProductGroups: build.query<DepartmentProductGroup[], Group>({
            query: (group) => `departments/${group.id}/productgroups`,
            // Cache for id
            providesTags: (_result, _error, groups) => [{ type: 'department_product_group', id: groups.id}],
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        }),
        putGroup: build.mutation<void, Group>({
            query: (group) => ({
                url: `departments`,
                method: 'PUT',
                body: group,
            }),
            transformErrorResponse: (response) => response.data,
            // Invalidate Cache for id
            invalidatesTags: (_result, _error, { id }) => [{ type: 'groups', id: 'LIST' }],
        }),
        postGroup: build.mutation<void, Group>({
            query: (body) => ({
                url: `departments`,
                method: 'POST',
                body,
            }),
            transformErrorResponse: (response) => response.data,
            invalidatesTags: [{ type: 'groups', id: 'LIST' }],
        }),
        postGroupCustomers: build.mutation<void, { group: Group, groupCustomers: GroupCustomer[] }>({
            query: (body) => ({
                url: `departments/${body.group.id}/customers`,
                method: 'POST',
                body: body.groupCustomers
            }),
            transformErrorResponse: (response) => response.data,
            invalidatesTags: (body, query, request) => [{ type: 'groups', id: request.group.id }],
        }),
        updateCustomerOrder: build.mutation<void, { groupId: number, customers: number[] }>({
            query: (body) => ({
                url: `departments/${body.groupId}/Customers`,
                method: 'POST',
                body: body.customers
            }),
            invalidatesTags: (isUpdated) => [{type: 'Customers', value:'LIST'}]
        }),
        postDepartmentProductGroups: build.mutation<void, { groupId: number, productGroupCodes: string[] }>({
            query: (body) => ({
                url: `departments/${body.groupId}/productgroups`,
                method: 'POST',
                body: body.productGroupCodes
            }),
            invalidatesTags: (_, __, items) => [{ type: 'department_product_group', id: items.groupId}]
        })
    }),
    overrideExisting: false,
})

export const {
    useGetGroupsQuery,
    usePutGroupMutation,
    usePostGroupMutation,
    useGetDepartmentCustomersQuery,
    useGetDepartmentMeasurementsQuery,
    useGetDepartmentProductGroupsQuery,
    useUpdateCustomerOrderMutation,
    usePostDepartmentProductGroupsMutation
} = groupsApi
